<template>
  <DebugThemeSwitcher :newsletter="newsletter" />
  <ZoomableImageProvider />
  <SearchProvider :newsletter="newsletter" />
  <SubscribeFormProvider
    :newsletter="newsletter"
    :subscriber-facing-authentication="subscriberFacingAuthentication"
    :variant="variant"
    :surveys="surveys"
    :form-id="formId"
  />
  <SubscribeModalProvider
    :newsletter="newsletter"
    :subscriber-facing-authentication="subscriberFacingAuthentication"
  />
  <FootnoteProvider />
  <HeaderMobileMenuProvider />
  <ManageSubscriptionProvider :newsletter="newsletter" />
  <CTAProvider
    :newsletter="newsletter"
    :subscriber-facing-authentication="subscriberFacingAuthentication"
  />
  <SurveyProvider
    v-if="variant === 'archive_page'"
    :newsletter="newsletter"
    :subscriber-facing-authentication="subscriberFacingAuthentication"
    :email-id="emailId"
  />
  <SubscriberToast :flash="subscriberFacingFlash" />
</template>

<script setup lang="ts">
import "bluesky-post-embed";
import "bluesky-profile-card-embed";

import { computed } from "vue";

import type { Newsletter } from "@/types/newsletter";

import CTAProvider from "./CTAProvider.vue";
import DebugThemeSwitcher from "./DebugThemeSwitcher.vue";
import FootnoteProvider from "./FootnoteProvider.vue";
import HeaderMobileMenuProvider from "./HeaderMobileMenuProvider.vue";
import ManageSubscriptionProvider from "./ManageSubscriptionProvider.vue";
import SearchProvider from "./SearchProvider.vue";
import {
  type FormSurvey,
  type SubscribeFormVariant,
  type SubscriberFacingAuthentication,
} from "./SubscribeForm/lib";
import SubscribeFormProvider from "./SubscribeFormProvider.vue";
import SubscribeModalProvider from "./SubscribeModalProvider.vue";
import SubscriberToast from "./SubscriberToast.vue";
import SurveyProvider from "./Survey/SurveyProvider.vue";
import ZoomableImageProvider from "./ZoomableImageProvider.vue";

defineProps<{
  newsletter: Newsletter;
  subscriberFacingAuthentication: SubscriberFacingAuthentication;
  subscriberFacingFlash: { message: string } | null;
  variant: SubscribeFormVariant;
  surveys: FormSurvey[];
  formId: string | null;
}>();

declare var EMAIL_ID: string | undefined;

const emailId = computed(() => {
  // Get email ID from the global EMAIL_ID variable set by the template
  if (typeof EMAIL_ID !== "undefined") {
    return EMAIL_ID;
  }
  return null;
});
</script>
